// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__THQGZ","videoContainer":"styles_videoContainer__DHkSp","video":"styles_video__A2BS1","poster":"styles_poster___c5CJ"};